import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="copyright"
export default class extends Controller {
    static targets = ["year"]

    yearTargetConnected(/** @type {HTMLElement} */element) {
        element.textContent = new Date().getFullYear()
    }
}
